<template>
  <div class="fixed left-4 right-4 bottom-4 z-50 sm:left-auto sm:right-6" style="max-width: 46rem;">
    <div class="rounded-3xl border-4 border-yellow-600 bg-gradient-to-br from-yellow-50 via-white to-amber-50 px-6 py-5 text-yellow-900 shadow-2xl" style="box-shadow: inset 0px -8px 0px #FBBF24, inset 0 -9px 0 0 #FFFBEB, inset 0px 2px 0px 2px #FFFBEB;">
      <div class="flex items-start gap-4">
        <div class="mt-0.5 flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-2xl border-2 border-yellow-600 bg-yellow-200 text-yellow-800" style="box-shadow: inset 0px -4px 0px #FBBF24, inset 0 -5px 0 0 #FFFBEB, inset 0px 1px 0px 1px #FFFBEB;">
          <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 16v-4m0-4h.01M10.29 3.86l-7.5 13A1 1 0 003.67 18h16.66a1 1 0 00.87-1.5l-7.5-13a1 1 0 00-1.74 0z" />
          </svg>
        </div>

        <div class="min-w-0 flex-1">
          <h3 class="text-2xl font-bold leading-tight text-yellow-900">A new version of this page is available</h3>
          <p class="mt-2 text-lg leading-relaxed text-yellow-800">Refresh to see the latest changes.</p>
        </div>
      </div>

      <div class="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
        <button
          type="button"
          class="inline-flex items-center justify-center rounded-xl border-4 border-gray-600 bg-gray-200 px-6 py-3 text-base font-bold text-gray-700 transition-all duration-200 hover:bg-gray-100 focus:outline-none focus:ring-4 focus:ring-gray-300 focus:ring-offset-2"
          style="box-shadow: inset 0px -6px 0px #9CA3AF, inset 0 -7px 0 0 #F3F4F6, inset 0px 1px 0px 1px #F3F4F6;"
          @click="$emit('dismiss')"
        >
          Not now
        </button>
        <button
          type="button"
          class="inline-flex items-center justify-center rounded-xl border-4 border-green-700 bg-green-300 px-6 py-3 text-base font-bold text-green-900 transition-all duration-200 hover:bg-green-200 focus:outline-none focus:ring-4 focus:ring-green-300 focus:ring-offset-2"
          style="box-shadow: inset 0px -6px 0px #34D399, inset 0 -7px 0 0 #ECFDF5, inset 0px 1px 0px 1px #ECFDF5;"
          @click="$emit('refresh')"
        >
          Refresh
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppUpdateNotice',
  emits: ['dismiss', 'refresh'],
};
</script>